var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-nav-item',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"href":_vm.url,"title":_vm.tooltip}},[_c('img',{attrs:{"src":require(("@/assets/" + _vm.imgsrc))}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }